var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.69,153.66h74.24v-12.4H71.69Zm86.27,0h12.69v-12.4H158Zm-111.34,0H59.31v-12.4H46.62Zm6.13-24H65.44v-12.4H52.75Zm24.71,0H90.15v-12.4H77.46Zm24.72,0h12.69v-12.4H102.18Zm24.72,0h12.7v-12.4H126.9Zm24.72,0h12.7v-12.4h-12.7Zm-98.87-24H65.44V93.22H52.75Zm24.71,0H90.15V93.22H77.46Zm24.72,0h12.69V93.22H102.18Zm24.72,0h12.7V93.22H126.9Zm24.72,0h12.7V93.22h-12.7ZM35,163.24H182.29V79.15H35Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.92,
    y1: 78.36,
    x2: 108.92,
    y2: 40.99
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/KEYBOARD.93008e8f50569368d7c15ad90ad74929.svg";
export { ForwardRef as ReactComponent };